import React from 'react';
import { ReferenceInput, AutocompleteInput, useLocaleState } from 'react-admin';


const CountryReferenceInput = (props) => {
    const [locale] = useLocaleState();
    const optionText = choice => (choice?.translations?.name && choice?.translations?.name[locale]) ? choice.translations.name[locale] : (choice.name ? choice.name : '');

    return (
        <ReferenceInput label="Country" source="country_id" reference="countries" sort={{ field: 'name', order: 'ASC' }} {...props}>
            <AutocompleteInput optionText={optionText} size="small" />
        </ReferenceInput>
    );
};

export default CountryReferenceInput;
